/* LaadkabelXL keuzehulp: merk -> model -> bouwjaar, daarna naar de resultatenpagina */
(function(){
  if(window.LXF) return;
  var REC={'11':'3-fase 16A / 11 kW','7,4':'1-fase 32A / 7','22':'3-fase 32A / 22 kW'};
  var D=null;
  function slug(s){return s.normalize('NFKD').replace(/[^\x00-\x7f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
  function data(){
    if(D) return D;
    var el=document.getElementById('lx-car-data'); if(!el) return {};
    var C=JSON.parse(el.textContent); D={};
    Object.keys(C).forEach(function(b){
      var g={},order=[];
      C[b].forEach(function(x){
        var p=x.split('|'),y=p[1].split('–'),y1=+y[0],y2=+(y[1]||y[0]);
        if(!g[p[0]]){g[p[0]]=[];order.push(p[0]);}
        g[p[0]].push({r:p[1],y1:y1,y2:y2,kw:p[2],h:p[3]||('laadkabel-'+slug(b+' '+p[0])+'-type-2')});
      });
      D[b]={order:order,g:g};
    });
    return D;
  }
  function opt(s,v,t){var o=document.createElement('option');o.value=v;o.textContent=t;s.appendChild(o);}
  function clear(s,t){s.innerHTML='';opt(s,'',t);s.disabled=true;}

  function init(form){
    if(form.__lx) return; form.__lx=true;
    var d=data();
    var sb=form.querySelector('[name=merk]'),sm=form.querySelector('[name=model]'),sy=form.querySelector('[name=jaar]'),btn=form.querySelector('[type=submit]');
    if(!sb||!sm||!sy) return;
    clear(sb,'Kies je merk');sb.disabled=false;
    Object.keys(d).sort(function(a,b){return a.localeCompare(b,'nl');}).forEach(function(k){opt(sb,k,k);});
    clear(sm,'Kies eerst je merk');clear(sy,'Kies eerst je model');
    if(btn) btn.disabled=true;
    function ready(){ if(btn) btn.disabled=!sy.value; }
    sb.addEventListener('change',function(){
      clear(sy,'Kies eerst je model');ready();
      var x=d[sb.value]; if(!x){clear(sm,'Kies eerst je merk');return;}
      clear(sm,'Kies je model'); x.order.forEach(function(m){opt(sm,m,m);}); sm.disabled=false;
      if(x.order.length===1){sm.value=x.order[0];sm.dispatchEvent(new Event('change'));}
      else if(!form.__prefilling) sm.focus();
    });
    sm.addEventListener('change',function(){
      ready();
      var x=d[sb.value],list=x&&x.g[sm.value];
      if(!list){clear(sy,'Kies eerst je model');return;}
      clear(sy,'Kies je bouwjaar');var ys=[];
      list.forEach(function(e,i){for(var y=e.y2;y>=e.y1;y--) ys.push({y:y,i:i,r:e.r});});
      ys.sort(function(a,b){return b.y-a.y||a.i-b.i;});
      var cnt={}; ys.forEach(function(o){cnt[o.y]=(cnt[o.y]||0)+1;});
      ys.forEach(function(o){opt(sy,o.i+':'+o.y,o.y+(cnt[o.y]>1?' (uitvoering '+o.r+')':''));});
      sy.disabled=false; if(!form.__prefilling) sy.focus();
    });
    sy.addEventListener('change',ready);
    form.addEventListener('submit',function(ev){
      ev.preventDefault(); if(!sy.value) return;
      var p=sy.value.split(':');
      var url=(form.getAttribute('action')||'/pages/jouw-laadkabel')+'?merk='+encodeURIComponent(sb.value)+'&model='+encodeURIComponent(sm.value)+'&jaar='+p[1]+'&v='+p[0];
      window.location.href=url;
    });
    form.lxBrand=function(b){ if(!d[b]) return; sb.value=b; sb.dispatchEvent(new Event('change')); };
    if(form.hasAttribute('data-lx-prefill')){
      var q=params(); if(q.merk&&d[q.merk]){
        form.__prefilling=true;
        sb.value=q.merk; sb.dispatchEvent(new Event('change'));
        if(d[q.merk].g[q.model]){ sm.value=q.model; sm.dispatchEvent(new Event('change'));
          var r=lookup(q); if(r){ sy.value=r.i+':'+r.jaar; } ready(); }
        form.__prefilling=false;
      }
    }
  }
  function params(){
    var o={}; new URLSearchParams(window.location.search).forEach(function(v,k){o[k]=v;}); return o;
  }
  function lookup(q){
    var d=data(),x=d[q.merk],list=x&&x.g[q.model]; if(!list) return null;
    var j=parseInt(q.jaar,10),i=parseInt(q.v,10);
    if(isNaN(i)||!list[i]||(j&&(j<list[i].y1||j>list[i].y2))){
      i=-1; list.forEach(function(e,k){ if(i<0&&j>=e.y1&&j<=e.y2) i=k; });
      if(i<0) i=0;
    }
    var e=list[i]; if(!j) j=e.y2;
    return {merk:q.merk,model:q.model,jaar:j,i:i,e:e,kw:e.kw,url:'/collections/'+e.h};
  }
  function LXT(s){var W={en:['charging-cable','type','to'],de:['ladekabel','typ','bis'],fr:['cable-de-recharge','type','a'],es:['cable-de-carga','tipo','a'],it:['cavo-di-ricarica','tipo','a'],pl:['kabel-do-ladowania','typ','do']}[(document.documentElement.lang||'nl').slice(0,2)];if(!W)return s;return ('-'+s+'-').replace(/-laadkabel-/g,'-'+W[0]+'-').replace(/-type-(?=\d)/g,'-'+W[1]+'-').replace(/-t-m-/g,'-'+W[2]+'-').slice(1,-1);}function byHandle(h){
    var d=data(),r=null; if(!h) return null;
    Object.keys(d).forEach(function(b){ if(r) return; d[b].order.forEach(function(m){ if(r) return;
      d[b].g[m].forEach(function(e,i){ if(!r&&(e.h===h||LXT(e.h)===h)) r={merk:b,model:m,jaar:e.y2,i:i,e:e,kw:e.kw,url:'/collections/'+e.h}; }); }); });
    return r;
  }
  window.LXF={init:init,lookup:lookup,params:params,byHandle:byHandle,REC:REC};
  function boot(){ document.querySelectorAll('form[data-lx-finder]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
